import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-3">
              吃瓜前线
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              吃瓜群众都在说什么
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3">
              来自一线吃瓜用户的真实声音，每一条评论都代表一份态度
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {commentsData.map((comment) => (
              <article
                key={comment.id}
                className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/70 flex flex-col"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center text-accent-700 font-bold text-sm flex-shrink-0">
                    {comment.nickname.charAt(0)}
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{comment.nickname}</div>
                    <div className="text-xs text-foreground-500">{comment.time}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  {comment.content}
                </p>
                <div className="mt-4 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-thumb-up-line text-accent-500"></i>
                  <span className="font-medium">{comment.likes.toLocaleString()}</span>
                  <span className="ml-1">赞同</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}